'use client'

import { getAssetUrl } from '@mntn-dev/app-assets'
import { CenteredLayout, SidebarLayout } from '@mntn-dev/ui-components'
import Image from 'next/image'
import type { PropsWithChildren } from 'react'

export const FocusedLayout = ({ children }: PropsWithChildren) => {
  return (
    <SidebarLayout>
      <CenteredLayout background="default">
        <div className="flex h-full flex-col items-center gap-8 py-8">
          <Image
            className="drop-shadow-blur"
            src={getAssetUrl('quickframe-logo')}
            alt=""
            width={200}
            height={200}
          />
          {children}
        </div>
      </CenteredLayout>
    </SidebarLayout>
  )
}
